import React from 'react';
import {
  BreakpointQueryName,
} from '@doveit/lego';
import * as styles from './StickyBar.style';

export interface StickyBarProps {
  dataRef?: string,
  visible?: boolean,
  hiddenFrom?: BreakpointQueryName,
  children: React.ReactNode,
}

const StickyBar: React.FC<StickyBarProps> = ({
  dataRef = 'sticky-bar',
  visible,
  hiddenFrom,
  children,
}) => (
  <div
    css={styles.main}
    $visible={visible}
    $hiddenFrom={hiddenFrom}
    data-ref={dataRef}
  >
    {children}
  </div>
);

export default StickyBar;
